import React, {useState} from 'react';
import {UsePermissions} from "../../hooks/usePermissions";
import {TableCompensacion} from "./components/TableCompensacion";
import {Navigate} from "react-router";
import {ModalNuevoCompensacion} from "./components/ModalNuevoCompensacion";
import {ModalEditarCompensacion} from "./components/ModalEditarCompensacion";

export const CompensacionPage = () => {
    const [permisos] = UsePermissions();
    const [displayNewModal, setDisplayNewModal] = useState(false);
    const [displayeditModal, setDisplayeditModal] = useState(false);
    const [fieldEdit, setFieldEdit] = useState({});
    const [reload, setReload] = useState(false);

    const editarUsuario= (e) => {
        setFieldEdit({...e});
        setDisplayeditModal(true);
    }

    const crearnuevoUsuario = () => {
        setDisplayNewModal(true);
    }

    const onHide = () => {
        setDisplayNewModal(false);
        setReload(true);
        resetLoad();
    }
    const onHideEdit = () => {
        setDisplayeditModal(false);
        setReload(true);
        resetLoad()
    }

    const resetLoad = () => {
        setTimeout(() =>{
            setReload(false);
        }, 2000)
    }
    return (
        <div className="container-relative">
            {permisos.consultar ? <TableCompensacion reload={reload} obtenerParametrosUser={editarUsuario} nuevoUsuario={crearnuevoUsuario} />: <Navigate to="/home"/> }
            <ModalNuevoCompensacion show={displayNewModal} hide={onHide}/>
            <ModalEditarCompensacion show={displayeditModal} hide={onHideEdit} fields={fieldEdit}/>
        </div>
    );
};

